import { render, staticRenderFns } from "./SVGHouse.vue?vue&type=template&id=0d152279&scoped=true&"
import script from "./SVGHouse.vue?vue&type=script&lang=js&"
export * from "./SVGHouse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d152279",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d152279')) {
      api.createRecord('0d152279', component.options)
    } else {
      api.reload('0d152279', component.options)
    }
    module.hot.accept("./SVGHouse.vue?vue&type=template&id=0d152279&scoped=true&", function () {
      api.rerender('0d152279', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/SVG/SVGHouse.vue"
export default component.exports